/**
 * Segment-keyed JSON dictionaries (same pattern as notification/translations/{SEGMENT}.json).
 * Webpack bundles every matching file under client/translations.
 */
const translationsContext = require.context('../translations', false, /\.json$/);

export function listBundledTranslationSegments() {
  return translationsContext.keys().map((k) => k.replace(/^\.\//, '').replace(/\.json$/, ''));
}

export function loadSegmentMessages(segment) {
  const path = `./${segment}.json`;
  if (!translationsContext.keys().includes(path)) {
    return {};
  }
  return translationsContext(path);
}
